import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { WorkstationService } from '@/infra/services/workstations';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

interface GetWorkstationsParams {
	organization_id: string;
	company_id: string;
	sector_id: string;
	line_id: string;
}

function isEnabled(params: GetWorkstationsParams): boolean {
	return !!params.organization_id && !!params.company_id && !!params.sector_id && !!params.line_id;
}

const Service = WorkstationService.getInstance();

export const useGetWorkstations = (params: GetWorkstationsParams) => {
	return useQuery<SelectOption[]>({
		queryKey: [QUERY_KEYS.GET_WORKSTATIONS, params],
		queryFn: async () => Service.getWorkstations(params),
		enabled: isEnabled(params)
	});
};
